import { ObjectFields, RequiredObject } from "../types/initialContent";

export const requiredObjects: RequiredObject[] = [
    { label: "Bulk Ops Relatorio", value: "bulk_ops_relatorio" }
];

export const objectField: ObjectFields = {
  bulk_ops_relatorio: [
    {
      title: "action",
      key: "action",
      type: "text",
      description: "create | update",
    },
    {
      title: "action_type",
      key: "action_type",
      type: "text",
      description: "ticket | user | organization",
    },
    {
      title: "requester",
      key: "requester",
      type: "text",
      description: "Id do usuário que disparou",
    },
    {
      title: "date",
      key: "date",
      type: "date",
      description: "Data da operação",
    },
    {
      title: "total_count",
      key: "total_count",
      type: "decimal",
      description: "Total de itens processados",
    },
    {
      title: "success_count",
      key: "success_count",
      type: "decimal",
      description: "Total de itens com sucesso",
    },
    {
      title: "failed_count",
      key: "failed_count",
      type: "decimal",
      description: "Total de itens com erro",
    },
    {
      title: "job_ids",
      key: "job_ids",
      type: "text",
      description: "Lista de job_ids (csv ou json)",
    },
    {
      title: "status",
      key: "status",
      type: "text",
      description: "completed | partial | failed | pending",
    },
    {
      title: "error_summary",
      key: "error_summary",
      type: "text",
      description: "Resumo dos erros (se houver)",
    },
  ],
};

